import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum TaskSecurityRight {
    CanAccess = 21000,
    ViewOtherTask = 21001,

    ManageManualTasks = 21002,
    ManageTaskChecklists = 21003,

    DeleteMyTasks = 21004,
    DeleteAnyTasks = 21005,
}

export class TaskSecurityModule extends BaseSecurityModule<TaskSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Tasks,
            [
                { _id: TaskSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: TaskSecurityRight.ViewOtherTask, name: "View Other User's Personal Task", basic: true },

                { _id: TaskSecurityRight.ManageManualTasks, name: "Manage Manual Tasks", basic: false },
                { _id: TaskSecurityRight.ManageTaskChecklists, name: "Manage Task Checklists", basic: false },

                { _id: TaskSecurityRight.DeleteMyTasks, name: "Delete Tasks Created By User", basic: false },
                { _id: TaskSecurityRight.DeleteAnyTasks, name: "Delete Any Tasks", basic: false },
            ] as SecurityRight<TaskSecurityRight>[]
        );
    }


}
